var _style, _path, _path2, _path3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitop40Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#ECB006;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M723.8,79.9c0,170.8,0,339.3,0,509c10.2,0,18.6,0,28.1,0c0-170.5,0-339.4,0-509 C741.7,79.9,733.6,79.9,723.8,79.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M675.6,449.5c-162,0-324.1,0-488.6,0c-19.8,46.6-39.7,93.4-60.6,142.3c13.8,0,23.6,0,35.2,0L207,484.9h224.3 c0,0,0.1,0.1,0.1,0.1l46.9,106.5c39,0,76.6,0,117.5,0c-17.6-41.6-34.4-81.4-52.4-124c36.4,0,69.2,0,104.3,0c0,41.1,0,80.8,0,121.7 c11.5,0,20.6,0,29.2,0c0.1-0.2,0.2-0.6,0.4-0.8V453.2C676.7,451.5,676.2,450.3,675.6,449.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M646.6,80.7v311.8h-136c-45.8-106-90.7-209.8-135.2-313H265.6C192.6,249.8,120,419.5,46.2,591.7h35.6 c25.9-60.6,51.8-121.1,78.3-182.9h517.1c0.1-0.1,0.1-0.3,0.1-0.4V80.7H646.6z M256.2,376l63.6-146l63.6,146H256.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.9,670.4v-30.5l-0.6-4.8h27.8c4.8,0,8.5,1,10.9,2.9c2.4,1.9,3.6,4.9,3.6,9v11.5c0,4.2-1.2,7.2-3.6,9.1 c-2.4,1.9-6,2.8-10.9,2.8H191.9z M203.6,662.1h13.7c3.1,0,4.6-1.4,4.7-4.3v-10.4c0-1.2-0.3-2.1-1-3c-0.7-0.8-1.9-1.2-3.7-1.2h-13.7 V662.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.9,670.4l17.6-35.3h15.6l17.5,35.3h-12.9l-2.9-6.4h-19l-3.3,6.4H235.9z M255.1,655.7h12.3l-5.8-12.8H261 L255.1,655.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M292.5,670.4v-30.5l-0.6-4.8h11l16.9,17.2l2.3,2.6h0.7v-19.8h11.5v35.3h-10L307,653.1l-2.3-2.8H304v20.2H292.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M355.6,670.4c-4.3,0-7.4-0.9-9.3-2.8c-1.9-1.9-2.9-4.9-2.9-9.1v-11c0-4.3,1.1-7.5,3.2-9.5c2.1-2,5.1-3,9-3 h17.5c2.8,0,4.9,0.1,6.3,0.5c1.5,0.3,2.2,0.6,2.2,0.9l-1.9,7.5c-1-0.1-3-0.2-5.9-0.4c-2.9-0.1-6.6-0.2-11-0.2h-3.1 c-1.9,0-3.2,0.4-3.8,1c-0.7,0.7-1,1.8-1,3.2v10.3c0,1.4,0.3,2.4,0.9,3.2c0.6,0.7,1.9,1.1,3.9,1.1h2.5c5.7,0,10.1-0.1,13.1-0.2 c3-0.1,4.8-0.3,5.4-0.5l3.7,6.5c0,0.2-0.4,0.5-1.2,0.9c-0.8,0.4-2.2,0.8-4.1,1.1c-1.9,0.3-4.6,0.5-8.1,0.5H355.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.5,670.4v-35.3H429v8.2h-26.8v5h19.9v8.3h-19.9v5.6h25.9l3.6,7.6c0,0.2-0.5,0.3-1.6,0.5 c-1.1,0.1-2.9,0.2-5.6,0.2H390.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.4,670.4c-4.3,0-7.4-0.9-9.3-2.8c-1.9-1.9-2.9-4.9-2.9-9.1v-11c0-4.3,1.1-7.5,3.2-9.5c2.1-2,5.1-3,9-3H480 c2.8,0,4.9,0.1,6.3,0.5c1.5,0.3,2.2,0.6,2.2,0.9l-1.9,7.5c-1-0.1-2.9-0.2-5.8-0.4c-2.9-0.1-6.6-0.2-11-0.2h-3.1 c-1.9,0-3.2,0.4-3.8,1c-0.7,0.7-1,1.8-1,3.2v10.3c0,1.4,0.3,2.4,0.9,3.2c0.6,0.7,1.9,1.1,3.9,1.1h2.5c5.7,0,10.1-0.1,13.1-0.2 c3-0.1,4.8-0.3,5.4-0.5l3.7,6.5c0,0.2-0.4,0.5-1.2,0.9s-2.2,0.8-4.1,1.1c-1.9,0.3-4.6,0.5-8.1,0.5H462.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.4,670.4v-35.3h11.6v13.4h18.7v-13.4h11.5v35.3h-11.5v-13.7h-18.7v13.7H497.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M544.4,670.4l17.6-35.3h15.6l17.5,35.3h-12.9l-2.9-6.4h-19l-3.3,6.4H544.4z M563.6,655.7h12.3l-5.8-12.8h-0.6 L563.6,655.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.3,671c-1.6,0-3.4-0.2-5.3-0.8c-2-0.5-3.9-1.7-5.8-3.7l-2.5-2.5c-1.2-1.2-2.3-2.2-3.4-2.9 c-1.1-0.8-2.4-1.3-3.8-1.7c-1.4-0.4-3.2-0.6-5.3-0.6h-0.5v11.6H601v-30.5l-0.6-4.9h27.8c2.6,0,4.6,0.3,6.2,0.9 c1.6,0.6,2.8,1.4,3.7,2.5c0.9,1,1.4,2.2,1.8,3.5c0.3,1.3,0.5,2.6,0.5,3.9v1.1c0,2.4-0.6,4.6-1.8,6.5c-1.2,1.9-3.2,3.2-5.8,4 c1,0.6,2,1.2,2.8,1.8c0.9,0.6,1.9,1.3,3.1,2c1.3,0.8,2.6,1.3,3.7,1.6c1.1,0.3,2.1,0.6,2.8,0.6c0.8,0.1,1.2,0.1,1.3,0.1l-1.8,6.8 c-0.5,0.1-1.2,0.2-2.2,0.4C641.5,670.9,640.4,671,639.3,671z M619.6,650.8c1,0,2,0,2.9-0.1c0.9,0,1.8-0.1,2.5-0.2 c1.4-0.2,2.3-0.6,2.8-1.3c0.5-0.7,0.8-1.5,0.8-2.5v-0.7c0-0.9-0.2-1.6-0.8-2c-0.5-0.5-1.4-0.7-2.7-0.7h-12.5v7.3 c1,0,2.1,0.1,3.3,0.1C617.2,650.8,618.4,650.8,619.6,650.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M660.1,670.4v-27.2h-14.3v-8.2h40.4v8.2h-14.5v27.2H660.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "129.9,611.3 118.6,617.5 128.1,627.1 135.5,616.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.9,678l-12.1,27.2c0.2,1.1,0.6,2.1,1,3.1l11.1-9.1V678z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "135.5,616.9 128.1,627.1 130.7,629.6 148.3,629.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "88.6,677.3 101,680.8 101,673.2 88.6,657.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "148.3,629.6 130.7,629.6 140,638.9 149.6,631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115.2,596.6 105.8,604.8 115,614 120,601.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,712.3c0,3.4,2.8,6.2,6.2,6.2c3.4,0,6.2-2.8,6.2-6.2v-14.9l-12.5,6.4V712.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.9,669.4l-12.5-1.9v34.1c0,1.2,0.1,2.4,0.4,3.5L79.9,678V669.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "120,601.4 115,614 118.6,617.5 129.9,611.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.7,672.7c1.3-1.3,2.5-2.8,3.5-4.3l-9.9-7.7c-0.6,1.1-1.5,2.2-2.4,3.2l-12.3,12.3h17.6L152.7,672.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.7,634l-3.1-3.1l-9.6,8l3.9,3.9c1.4,1.4,2.4,3,3.2,4.7l13.4,2.2C159.6,644,157.1,638.4,152.7,634z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "131.5,676.2 127,680.7 138.2,687.2 149.2,676.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.3,703.8 58.7,697.4 58.7,693.7 46.3,688.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.9,694.8c-2.4,2.4-2.4,6.4,0,8.8c2.4,2.4,6.4,2.4,8.8,0l11.2-11.2h-17.6L112.9,694.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.6,681.6l12.2,22.9c0.2-0.9,0.2-1.9,0.2-2.8v-20.9l-12.5-3.5V681.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "115.3,692.4 132.9,692.4 138.2,687.2 127,680.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.6,701.7c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4v-2.5l-11.1,9.1c2.6,6,8.5,10.2,15.4,10.2 c6.7,0,12.5-4,15.2-9.7l-10.9-9.9V701.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.6,698.9l10.9,9.9c0.6-1.3,1.1-2.8,1.3-4.3l-12.2-22.9V698.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.4,649.7l-13.4-2.2c1.2,2.7,1.5,5.7,0.9,8.6l12.7-2.3C160.7,652.4,160.6,651.1,160.4,649.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M160.7,653.8l-12.7,2.3c-0.3,1.6-0.9,3.1-1.7,4.6l9.9,7.7C159.1,663.9,160.6,658.9,160.7,653.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.9,654 67.4,664 67.4,667.6 79.9,669.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "88.6,630.8 101,645.9 101,632.6 88.6,628.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,589c-2.4,0-4.6,0.5-6.6,1.4l3.4,12.6c0.8-0.9,2-1.5,3.3-1.5c1.3,0,2.5,0.6,3.3,1.5l8.1-9.5 C71.5,590.7,67.5,589,63.1,589z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.6,606.1v22.3l12.5,4.2v-7.8L88.8,602C88.7,603.2,88.6,604.6,88.6,606.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.9,648.4 67.4,637.5 67.4,664 79.9,654  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3,605.8v5.1l12.5,1.1v-6.2c0-1.1,0.4-2.1,1.1-2.9l-3.4-12.6C50.4,592.9,46.3,598.9,46.3,605.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.9,618.9 67.4,609 67.4,631.8 79.9,623.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.9,623.7 67.4,631.8 67.4,637.5 79.9,648.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "88.6,653.9 101,655 101,645.9 88.6,630.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.9,605.8c0-4.9-2.1-9.3-5.4-12.3l-8.1,9.5c0.6,0.8,1,1.7,1,2.8v3.3l12.5,9.9V605.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.8,602l12.2,22.9v-18.8c0-0.2,0-0.4,0-0.6l-11.5-6.9C89.2,599.6,89,600.7,88.8,602z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.3,652.5 58.7,650.5 58.7,647.5 46.3,642.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.3,660 58.7,670.9 58.7,650.5 46.3,652.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.3,614.6 58.7,625.5 58.7,612 46.3,610.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.3,680.2 58.7,676.3 58.7,670.9 46.3,660  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.1,595.5c-7.9-7.9-14.3-7-17.3-5.7c-2.3,0.9-5.6,3.2-7.3,8.8l11.5,6.9c0.1-2.1,0.4-3.3,0.6-3.9 c0.7,0.3,1.9,1,3.6,2.7l0.5,0.5l9.4-8.2L114.1,595.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.3,688.1 58.7,693.7 58.7,676.3 46.3,680.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.3,634.2 58.7,629.1 58.7,625.5 46.3,614.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "88.6,657.2 101,673.2 101,655 88.6,653.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "46.3,642.4 58.7,647.5 58.7,629.1 46.3,634.2  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitop40Logo);
export default __webpack_public_path__ + "static/media/aitop40-logo.2297bb8f1ee4cb39e20fbdfdb6f61177.svg";
export { ForwardRef as ReactComponent };